import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAnalyticsKey } from '../../utils/keys';
export const useAnalytics = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options;
    const { client } = useTribeClient();
    const analyticsKey = getAnalyticsKey({ variables, fields });
    return useQuery(analyticsKey, () => client.report.analytics(variables, fields), useQueryOptions);
};
//# sourceMappingURL=useAnalytics.js.map